import React, { useEffect, useState } from "react";
import { api, gbp } from "@/lib/api";

export default function AdminCustomers() {
  const [customers, setCustomers] = useState([]);
  useEffect(() => { api.get("/admin/customers").then((r) => setCustomers(r.data)); }, []);
  return (
    <div>
      <h1 className="font-serif-display text-4xl mb-8">Customers</h1>
      <div className="bg-white border border-brand-border rounded-sm overflow-hidden">
        <table className="w-full text-sm"><thead className="bg-brand-blush/40 text-left"><tr><th className="px-4 py-3">Name</th><th className="px-4 py-3">Email</th><th className="px-4 py-3">Orders</th><th className="px-4 py-3">Joined</th></tr></thead>
          <tbody>{customers.map((c) => (<tr key={c.id} className="border-t border-brand-border" data-testid={`customer-${c.id}`}><td className="px-4 py-3">{c.name}</td><td className="px-4 py-3 text-muted-foreground">{c.email}</td><td className="px-4 py-3">{c.order_count}</td><td className="px-4 py-3 text-muted-foreground">{new Date(c.created_at).toLocaleDateString("en-GB")}</td></tr>))}</tbody>
        </table>
        {customers.length === 0 && <p className="p-6 text-sm text-muted-foreground">No customers yet.</p>}
      </div>
    </div>
  );
}
